import ProductsListView from "./ProductsListView";

import "./ProductsListView.scss";

export * from "./ProductsListView.types";

export { ProductsListView };
